import styled from 'styled-components';

export const OverlayContainer = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.color.whiteRGBA(0.8)};
  z-index: 9999;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  > p {
    margin-top: ${({ theme }) => theme.x3spacePx}px;
    color: ${({ theme }) => theme.color.spaceGray};
    text-align: center;
    font-size: ${(props) => props.theme.x3space - 0.4}rem;
  }
`;
